import { useEffect } from "react";

export default function RedirectPage() {
  useEffect(() => {
    // Redirect logic here
    window.location.href = "/corporate/login";
  }, []);

  return null;
}

// This function runs on the server when a request is made to this page.
export async function getServerSideProps({ params }) {
  // Check if the path is /corporates/login.php
  if (params.slug.join("/") === "corporates/login.php") {
    // Redirect to /corporate/login
    return {
      redirect: {
        destination: "/corporate/login",
        permanent: true, // Use 'permanent: false' for temporary redirects
      },
    };
  }

  if (params.slug.join("/") === "corporates/signup.php") {
    // Redirect to /corporate/login
    return {
      redirect: {
        destination: "/corporate/signup",
        permanent: true, // Use 'permanent: false' for temporary redirects
      },
    };
  }
  if (params.slug.join("/") === "/wp-content/uploads/2022/08/457.pdf") {
    // Redirect to /corporate/login
    return {
      redirect: {
        destination: "/sample-report",
        permanent: true, // Use 'permanent: false' for temporary redirects
      },
    };
  }
  if (params.slug.join("/") === "corporates/dashboard.php") {
    // Redirect to /corporate/login
    return {
      redirect: {
        destination: "/corporate/login",
        permanent: true, // Use 'permanent: false' for temporary redirects
      },
    };
  }

  // If not redirected, return an empty object
  return {
    props: {},
  };
}
